import { object, InferType } from 'yup'

export const userSettingsSchema = object({})

export type UserSettings = InferType<typeof userSettingsSchema>
